import { FC, useEffect, useState } from "react";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import {
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  FilledButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import { storeDeletePayload } from "../../../Redux/Actions/popupActions";
import store from "../../../Store/store";
import { useGetApi } from "../../../Redux/Hooks/useGetApi";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../Loading";
import { ConfirmPopupType } from "../../../Interfaces/IAddFieldModalProps";
import { consolelog } from "../../../helpers/consolelog";

const ConfirmPopup: FC<ConfirmPopupType> = ({ handleClose, isOpen, title }) => {
  const [message, setMessage] = useState<string>();
  const [confirmButtonDisabled, setConfirmButtonDisabled] =
    useState<boolean>(true);
  const filter = useSelector((state: any) => state.searchReducer);
  const onSuccess = (data: any, method: string) => {
    consolelog("onSuccess callback");
  };
  const onError = (error: any) => {
    consolelog("onError callback", error);
  };

  let params = {
    service: endpoints.getProductData(),
    skip: 0,
    take: 10,
    isEnabled: true,
    filter: encodeURIComponent(
      `tolower(FamilyGroup) eq '${filter.data.rowToBeDelete.FamilyGroup?.toLowerCase()}' and ProductType eq ${
        filter.data.rowToBeDelete.ProductType == null
          ? null
          : `'${filter.data.rowToBeDelete.ProductType}'`
      }`
    ),
    refetchOnWindowFocus: false,
    isPaginationRequired: true,
    key: filter.data.rowToBeDelete.Id,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result, "get");
    },
  };

  const {
    data: apiResponse,
    isLoading,
    refetch,
    isSuccess,
  } = useGetApi(params);

  useEffect(() => {
    if (
      apiResponse !== undefined &&
      apiResponse?.response !== undefined &&
      apiResponse?.response?.status !== 200
    ) {
      let text = `Product service returned response code "${
        apiResponse.response.status
      }", as of now can't ${title.toLocaleLowerCase()} 
      ${
        filter.data.rowToBeDelete.FamilyGroup
      }\n please try again after sometime.`;
      setMessage(text);
      setConfirmButtonDisabled(true);
    } else if (
      isSuccess &&
      (apiResponse?.status === 200 ||
        (apiResponse?.response?.status === 200 &&
          apiResponse?.response !== undefined)) &&
      apiResponse !== undefined &&
      apiResponse?.data?.value?.length > 0
    ) {
      let text = `Family Group '${
        filter.data.rowToBeDelete.FamilyGroup
      }' with ProductType '${
        filter.data.rowToBeDelete.ProductType
      }' associated with ${
        apiResponse?.data["@odata.count"]
      } Products.\n You cannot ${title.toLocaleLowerCase()} this.`;
      setMessage(text);
      setConfirmButtonDisabled(true);
    } else if (!isLoading) {
      setMessage(
        `Are you sure you want to ${title.toLocaleLowerCase()}  the family group?`
      );
      setConfirmButtonDisabled(false);
    }
  }, [apiResponse, isLoading, isSuccess]);
  const confirm = () => {
    store.dispatch(
      storeDeletePayload({ deletePayload: filter.data.rowToBeDelete.Id })
    );
    handleClose(false);
  };
  return (
    <>
      <div
        style={{
          position: "relative",
          minHeight: "20rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Modal
          small
          handleClose={() => handleClose(false)}
          open={isOpen}
          headingId="info-modal"
          stickyHeader="Sticky Header"
          restrictClose={true}
        >
          <ModalHeading element="h5">{message}</ModalHeading>
          <ButtonGroupWrapper actionbar>
            <ButtonGroupPrimary>
              <OutlinedButton
                className="ln-u-margin-right"
                onClick={() => handleClose(false)}
              >
                Cancel
              </OutlinedButton>
              {!confirmButtonDisabled && (
                <FilledButton onClick={() => confirm()}>Yes</FilledButton>
              )}
            </ButtonGroupPrimary>
          </ButtonGroupWrapper>
        </Modal>
      </div>

      {isLoading && <LoadingIndicator />}
    </>
  );
};

export default ConfirmPopup;
